var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-flex",
    { attrs: { column: "" } },
    [
      _c("v-parallax", {
        attrs: {
          src: "https://gm.goz.fun/wp-content/uploads/2023/03/complete-oauth-cover.jpg",
          height: "150",
          role: "img",
          "aria-label": "OAuth completion background",
        },
      }),
      _vm._v(" "),
      _c(
        "v-card",
        { attrs: { color: "primary" } },
        [
          _c(
            "v-layout",
            { attrs: { "pb-2": "", color: "primary" } },
            [
              _c(
                "v-flex",
                {
                  attrs: {
                    xs12: "",
                    sm12: "",
                    md12: "",
                    lg8: "",
                    "offset-lg2": "",
                    "justify-center": "",
                  },
                },
                [
                  _c(
                    "v-card",
                    {
                      staticClass: "profile-section-card--flex-toolbar",
                      attrs: { flat: "", color: "primary" },
                    },
                    [
                      _c(
                        "v-app-bar",
                        { attrs: { flat: "", color: "secondary" } },
                        [
                          _c(
                            "v-toolbar-title",
                            {
                              staticClass: "text-body-2",
                              attrs: { role: "heading", "aria-level": "1" },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$t("components.oauthProfile.title")
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-stepper",
                        {
                          attrs: { "alt-labels": "" },
                          model: {
                            value: _vm.steps,
                            callback: function ($$v) {
                              _vm.steps = $$v
                            },
                            expression: "steps",
                          },
                        },
                        [
                          _c(
                            "v-stepper-header",
                            [
                              _c(
                                "v-stepper-step",
                                {
                                  attrs: {
                                    complete: _vm.steps > 0,
                                    step: "1",
                                    "aria-label": "Step 1: Start",
                                    role: "columnheader",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$t(
                                          "components.oauthProfile.subtitle"
                                        )
                                      ) +
                                      "\n              "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("v-divider"),
                              _vm._v(" "),
                              _c(
                                "v-stepper-step",
                                {
                                  attrs: {
                                    complete: _vm.steps > 1,
                                    step: "2",
                                    "aria-label": "Step 2: Verify Email",
                                    role: "columnheader",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$t(
                                          "components.oauthProfile.steppers.verifyEmail"
                                        )
                                      ) +
                                      "\n              "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("v-divider"),
                              _vm._v(" "),
                              _c(
                                "v-stepper-step",
                                {
                                  attrs: {
                                    complete: _vm.steps > 2,
                                    step: "3",
                                    "aria-label": "Step 3: Setup Account",
                                    role: "columnheader",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$t(
                                          "components.oauthProfile.steppers.setupAccount"
                                        )
                                      ) +
                                      "\n              "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("v-divider"),
                              _vm._v(" "),
                              _c(
                                "v-stepper-step",
                                {
                                  attrs: {
                                    complete: _vm.steps > 3,
                                    step: "4",
                                    "aria-label": "Step 4: Completed",
                                    role: "columnheader",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$t(
                                          "components.oauthProfile.steppers.completed"
                                        )
                                      ) +
                                      "\n              "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-stepper-items",
                            { attrs: { color: "primary" } },
                            [
                              _c(
                                "v-stepper-content",
                                { attrs: { step: "2" } },
                                [
                                  _c("v-card", {
                                    staticClass: "mb-12",
                                    attrs: {
                                      height: "200px",
                                      "aria-label": "Verification step content",
                                      role: "none",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        "aria-label": "Next step",
                                        role: "button",
                                        color: "accent",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.setStep(3)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.$t(
                                              "components.oauthProfile.buttons.next"
                                            )
                                          ) +
                                          "\n                "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        "aria-label": "Cancel step",
                                        role: "button",
                                        text: "",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Cancel\n                "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-stepper-content",
                                { attrs: { step: "3" } },
                                [
                                  _c("CompleteOAuthProfileForm", {
                                    attrs: {
                                      "aria-label": "OAuth setup form",
                                      role: "form",
                                    },
                                    on: {
                                      "complete-oauth": function ($event) {
                                        return _vm.setStep(4)
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-stepper-content",
                                { attrs: { step: "4" } },
                                [
                                  _c(
                                    "v-card",
                                    { attrs: { flat: "" } },
                                    [
                                      _c(
                                        "v-container",
                                        {
                                          attrs: {
                                            fluid: "",
                                            "grid-list-md": "",
                                            role: "none",
                                            "aria-label":
                                              "Completed account overview",
                                          },
                                        },
                                        [
                                          _c("Overview", {
                                            attrs: {
                                              username: _vm.username,
                                              email: _vm.email,
                                              "zushin-points": _vm.zushinPoints,
                                              "total-referred":
                                                _vm.totalReferred,
                                              "total-referred-completed":
                                                _vm.totalReferredCompleted,
                                              "referral-link": _vm.referralLink,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        "aria-label":
                                          "Finish and go to profile",
                                        role: "link",
                                        color: "accent",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.redirectToProfile()
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.$t(
                                              "components.oauthProfile.buttons.done"
                                            )
                                          ) +
                                          "\n                "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-card", { attrs: { flat: "" } }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }